import React from "react";
import CheckoutForm from "./checkoutForm";
import AutoPayBox from "./autoPayBox";
import {CustomGrid} from "../custom-common";

const CreditCardPm = ({ YourCost, strings }) => (
    <CustomGrid.Row columns={2}>
        <CustomGrid.Column>
            <CheckoutForm
                strings={strings}
                YourCost={YourCost} />
        </CustomGrid.Column>
        <CustomGrid.Column>
            <AutoPayBox strings={strings} />
        </CustomGrid.Column>
    </CustomGrid.Row>
)

export default CreditCardPm;
